(function () {
  'use strict';
  if (window.dwMobileSearch) return;
  var root = document.documentElement;
  var mobile = window.matchMedia('(max-width: 991px)');
  var labelsNode = document.getElementById('DwMobileSearchLabels');
  var labels = labelsNode ? JSON.parse(labelsNode.textContent) : {};
  var historyKey = 'boost-sd-recent-searches';
  var panel = null;
  var isolated = new Set();
  var returnFocus = null;
  var scheduled = false;
  var dismissed = false;
  var interacted = false;
  var query = '';
  var statusTimer = null;
  var installed = null;
  var suppressFocus = false;
  var dialog = null;
  var hostParent = null;
  var hostNext = null;
  var openTimer = null;
  var wantedOpen = false;
  var openAttempts = 0;

  function controller() {
    return window.boostISWModule && window.boostISWModule.instantSearchController;
  }

  function history() {
    try {
      var raw = JSON.parse(localStorage.getItem(historyKey) || '[]');
      var seen = new Set();
      if (!Array.isArray(raw)) return [];
      return raw.filter(function (item) {
        if (!item || typeof item.title !== 'string') return false;
        var title = item.title.trim();
        var key = title.toLocaleLowerCase() + '|' + (item.extraParam || '');
        if (!title || seen.has(key)) return false;
        seen.add(key);
        return true;
      }).slice(0, 10);
    } catch (error) {
      return [];
    }
  }

  function setHistory(items) {
    try {
      if (items.length) localStorage.setItem(historyKey, JSON.stringify(items));
      else localStorage.removeItem(historyKey);
    } catch (error) {}
  }

  function decode(value) {
    var node = document.createElement('textarea');
    node.innerHTML = String(value || '');
    return node.value.trim();
  }

  function findPanel() {
    var node = document.querySelector('.boost-sd__search-bar-wrapper--mobile:not(.boost-sd__g-hide)');
    return mobile.matches && node && node.getBoundingClientRect().height > 0 ? node : null;
  }

  function viewport() {
    var view = window.visualViewport;
    root.style.setProperty('--dw-search-vv-height', Math.round(view ? view.height : window.innerHeight) + 'px');
    root.style.setProperty('--dw-search-vv-top', Math.round(view ? view.offsetTop : 0) + 'px');
  }

  function isolate(active) {
    if (!active) {
      isolated.forEach(function (node) { node.removeAttribute('inert'); });
      isolated.clear();
      return;
    }
    var child = active;
    while (child.parentElement) {
      Array.from(child.parentElement.children).forEach(function (node) {
        if (node === child || node.matches('script,style,link,meta,[role="status"],[aria-live]') || node.hasAttribute('inert')) return;
        node.setAttribute('inert', '');
        isolated.add(node);
      });
      if (child.parentElement === document.body) break;
      child = child.parentElement;
    }
  }

  function inputFor(active) {
    return active && active.querySelector('input[name="q"]');
  }

  function showStatus(text, pending) {
    if (!panel) return;
    var status = panel.querySelector('.dw-search-status');
    if (!status) return;
    status.textContent = text || '';
    status.hidden = !text;
    panel.classList.toggle('dw-search-pending', !!pending);
    panel.querySelector('.boost-sd__search-bar-autocomplete')?.setAttribute('aria-busy', pending ? 'true' : 'false');
  }

  function loading() {
    clearTimeout(statusTimer);
    if (!query.trim()) { showStatus('', false); return; }
    showStatus(labels.loading, true);
    statusTimer = setTimeout(function () {
      if (panel && query.trim()) showStatus(labels.retry, true);
    }, 7000);
  }

  function refreshHistory() {
    var c = controller();
    if (!c || !c.defaultData) return;
    c.defaultData.recentSearches = history().slice(0, 3);
    if (!query.trim()) c.renderDefaultData();
  }

  function makeButton(className, text, ariaLabel) {
    var button = document.createElement('button');
    button.type = 'button';
    button.className = className;
    button.textContent = text;
    button.setAttribute('aria-label', ariaLabel);
    return button;
  }

  function decorateHistory(scope) {
    scope.querySelectorAll('.boost-sd__suggestion-queries-header--recent').forEach(function (heading) {
      var group = heading.closest('.boost-sd__suggestion-queries-group');
      if (!group) return;
      heading.removeAttribute('tabindex');
      heading.removeAttribute('role');
      if (!group.querySelector('.dw-search-clear-history')) {
        var actions = document.createElement('div');
        actions.className = 'dw-search-history-actions';
        heading.before(actions);
        actions.appendChild(heading);
        var clear = makeButton('dw-search-clear-history', labels.clearAll, labels.clearAllLabel);
        clear.addEventListener('click', function () {
          setHistory([]);
          refreshHistory();
          inputFor(panel)?.focus({ preventScroll: true });
        });
        actions.appendChild(clear);
      }
      group.querySelectorAll('.boost-sd__suggestion-queries-item--recent').forEach(function (item, index) {
        item.hidden = index >= 3;
        var link = item.querySelector('a');
        var title = item.getAttribute('data-title') || link?.textContent.trim() || '';
        if (link) link.title = title;
        if (item.querySelector('.dw-search-remove')) return;
        var remove = makeButton('dw-search-remove', '×', (labels.remove || '').replace('__TERM__', title));
        remove.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          setHistory(history().filter(function (entry) { return entry.title !== title; }));
          refreshHistory();
          inputFor(panel)?.focus({ preventScroll: true });
        });
        item.appendChild(remove);
      });
    });
    var empty = scope.querySelector('.boost-sd__instant-search-no-product');
    if (empty && !empty.querySelector('.boost-sd__suggestion-queries-item,.dw-search-empty') && !query.trim()) {
      var hint = document.createElement('p');
      hint.className = 'dw-search-empty';
      hint.textContent = labels.hint;
      empty.appendChild(hint);
    }
  }

  function decorate(active) {
    var input = inputFor(active);
    var form = input?.closest('form');
    if (!input || !form) return;
    input.setAttribute('type', 'search');
    input.setAttribute('enterkeyhint', 'search');
    input.setAttribute('autocapitalize', 'off');
    input.setAttribute('spellcheck', 'false');
    var placeholder = document.querySelector('.dw-header-search input[name="q"]')?.getAttribute('placeholder') || labels.placeholder;
    input.setAttribute('aria-label', placeholder);
    input.setAttribute('aria-controls', 'boost-sd__search-bar-autocomplete-wrapper');
    input.removeAttribute('aria-owns');
    input.setAttribute('aria-expanded', 'true');
    input.placeholder = placeholder;
    var label = form.querySelector('label');
    if (label) label.htmlFor = input.id;
    form.querySelectorAll('button[role="textbox"]').forEach(function (button) { button.removeAttribute('role'); });
    form.querySelector('[data-group="close-search-form"]')?.setAttribute('aria-label', labels.close);
    if (dialog?.open) {
      active.removeAttribute('role');
      active.removeAttribute('aria-modal');
    } else {
      active.setAttribute('role', 'dialog');
      active.setAttribute('aria-modal', 'true');
    }
    active.setAttribute('aria-label', labels.submit);
    if (!form.querySelector('.dw-search-submit')) {
      var submit = makeButton('dw-search-submit', '', labels.submit);
      submit.innerHTML = '<svg aria-hidden="true" viewBox="0 0 24 24"><circle cx="10" cy="10" r="6"></circle><path d="m15 15 6 6"></path></svg>';
      submit.addEventListener('click', function (event) {
        var c = controller();
        if (c) c.handleSubmit(event, input);
        else form.requestSubmit();
      });
      form.appendChild(submit);
    }
    if (!active.querySelector('.dw-search-status')) {
      var status = document.createElement('p');
      status.className = 'dw-search-status';
      status.hidden = true;
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      form.after(status);
    }
    var results = active.querySelector('.boost-sd__instant-search-results');
    var footer = active.querySelector('.boost-sd__view-all');
    if (results && footer && footer.parentElement !== results) results.appendChild(footer);
    decorateHistory(active);
  }

  function modal(active) {
    var host = document.getElementById('bc-instant-search');
    if (active && host && typeof HTMLDialogElement !== 'undefined') {
      if (!dialog) {
        dialog = document.createElement('dialog');
        dialog.className = 'dw-search-dialog';
        dialog.setAttribute('aria-label', labels.submit);
        dialog.addEventListener('cancel', function (event) { event.preventDefault(); close(); });
        document.body.appendChild(dialog);
      }
      if (host.parentElement !== dialog) {
        hostParent = host.parentElement;
        hostNext = host.nextSibling;
        dialog.appendChild(host);
      }
      if (!dialog.open) {
        dialog.showModal();
        inputFor(active)?.focus({ preventScroll: true });
      }
    } else if (dialog && dialog.open) {
      suppressFocus = true;
      dialog.close();
      suppressFocus = false;
      if (host && hostParent) hostParent.insertBefore(host, hostNext?.parentNode === hostParent ? hostNext : null);
      hostParent = null;
      hostNext = null;
    }
  }

  function restoreFocus() {
    var target = returnFocus;
    if (!target || !target.isConnected || target.closest('[inert]')) return;
    suppressFocus = true;
    target.focus({ preventScroll: true });
    suppressFocus = false;
  }

  function requestOpen() {
    wantedOpen = true;
    clearTimeout(openTimer);
    openAttempts = 0;
    function retry() {
      if (!wantedOpen || dismissed || !mobile.matches) return;
      install();
      var c = controller();
      if (!c?.initialized) {
        if (openAttempts++ < 100) openTimer = setTimeout(retry, 150);
        return;
      }
      wantedOpen = false;
      if (c.state.isOpen) {
        c.ensureMobileWrapperVisible();
        schedule();
        return;
      }
      var input = document.querySelector('.dw-header-search input[name="q"]');
      if (!input) return;
      c.syncAllInputs(query);
      c.state.currentQuery = query;
      c.openSuggestion(input).then(function () {
        if (dismissed) return;
        c.ensureMobileWrapperVisible();
        if (query.trim()) c.searchAndRender(query);
        else c.renderDefaultData();
        schedule();
      });
    }
    openTimer = setTimeout(retry, 250);
  }

  function close() {
    var c = controller();
    dismissed = true;
    wantedOpen = false;
    clearTimeout(openTimer);
    clearTimeout(statusTimer);
    if (c) c.closeSuggestion();
    if (panel) panel.classList.add('boost-sd__g-hide');
    sync();
    restoreFocus();
  }

  function install() {
    var c = controller();
    if (!c || installed === c || typeof c.render !== 'function') return;
    installed = c;
    var originalNavigationRoot = c.getNavigationRoot;
    c.getNavigationRoot = function () {
      return panel || originalNavigationRoot.apply(this, arguments);
    };
    var originalFocus = c.handleInputFocus;
    c.handleInputFocus = function () {
      if (!suppressFocus) return originalFocus.apply(this, arguments);
    };
    var originalClose = c.closeSuggestion;
    c.closeSuggestion = function () {
      dismissed = true;
      wantedOpen = false;
      clearTimeout(openTimer);
      clearTimeout(statusTimer);
      this.instantSearchService?.cancelSearch();
      var result = originalClose.apply(this, arguments);
      schedule();
      return result;
    };
    var originalDefault = c.renderDefaultData;
    c.renderDefaultData = function () {
      if (this.defaultData) this.defaultData.recentSearches = history().slice(0, 3);
      return originalDefault.apply(this, arguments);
    };
    var originalRender = c.render;
    var originalReplace = c.replaceHTML;
    var renderQuery = null;
    var nextData = null;
    var rendering = false;
    function relevant(data) {
      return !mobile.matches || !interacted || !document.querySelector('.boost-sd__instant-search-container') || (!dismissed && decode(data.query) === query.trim());
    }
    c.replaceHTML = function () {
      if (renderQuery !== null && !relevant({ query: renderQuery })) return;
      return originalReplace.apply(this, arguments);
    };
    c.render = async function (data) {
      if (!relevant(data)) return;
      nextData = data;
      if (rendering) return;
      rendering = true;
      try {
        while (nextData) {
          var current = nextData;
          nextData = null;
          if (!relevant(current)) continue;
          renderQuery = current.query || '';
          var attempts = 0;
          while (this.isRendering && attempts++ < 125) await new Promise(function (resolve) { setTimeout(resolve, 16); });
          if (relevant(current)) await originalRender.call(this, current);
        }
      } finally {
        renderQuery = null;
        rendering = false;
      }
    };
  }

  function sync() {
    scheduled = false;
    install();
    var active = findPanel();
    if (active && !panel) {
      query = inputFor(active)?.value || query;
      viewport();
    }
    if (!active && panel) {
      panel.removeAttribute('role');
      panel.removeAttribute('aria-modal');
      inputFor(panel)?.setAttribute('aria-expanded', 'false');
      panel.classList.remove('dw-search-pending');
      clearTimeout(statusTimer);
    }
    panel = active;
    root.classList.toggle('dw-mobile-search-open', !!active);
    if (!active || (active && !dialog?.open)) isolate(null);
    modal(active);
    isolate(active);
    if (active) decorate(active);
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    queueMicrotask(sync);
  }

  function start() {
    viewport();
    install();
    var observer = new MutationObserver(function (changes) {
      if (changes.some(function (change) {
        if (change.type === 'attributes') return change.target === document.body || change.target.matches('.boost-sd__search-bar-wrapper--mobile');
        return change.target === document.body || Array.from(change.addedNodes).some(function (node) {
          return node.nodeType === 1 && (node.matches('#bc-instant-search,.boost-sd__instant-search-results') || node.querySelector('.boost-sd__search-bar-wrapper--mobile'));
        });
      })) schedule();
    });
    observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    document.addEventListener('pointerdown', function (event) {
      if (!mobile.matches) return;
      if (!event.target.closest('.dw-header-search input[name="q"],.js-search-header,.boost-sd__search-bar-input')) {
        if (!panel) { wantedOpen = false; clearTimeout(openTimer); }
        return;
      }
      interacted = true;
      dismissed = false;
      if (!panel) {
        returnFocus = event.target.closest('input,a,button');
        query = document.querySelector('.dw-header-search input[name="q"]')?.value || '';
        requestOpen();
      }
      install();
    }, true);
    document.addEventListener('focusin', function (event) {
      if (suppressFocus) { event.stopImmediatePropagation(); return; }
      if (panel && !panel.contains(event.target)) {
        event.stopImmediatePropagation();
        inputFor(panel)?.focus({ preventScroll: true });
      }
    }, true);
    document.addEventListener('input', function (event) {
      if (!mobile.matches || !event.target.matches('.boost-sd__search-widget-init-input,.dw-header-search input[name="q"]')) return;
      install();
      interacted = true;
      dismissed = false;
      query = event.target.value;
      if (!panel) requestOpen();
      loading();
    }, true);
    document.addEventListener('click', function (event) {
      if (!panel) return;
      if (event.target.closest('[data-group="close-search-form"]')) {
        event.preventDefault();
        event.stopImmediatePropagation();
        close();
      }
      if (event.target.closest('[data-group="clear-search-form"]')) {
        query = '';
        clearTimeout(statusTimer);
        showStatus('', false);
      }
    }, true);
    document.addEventListener('keydown', function (event) {
      if (!panel) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        event.stopImmediatePropagation();
        close();
      }
      if (event.key === 'Tab') {
        var items = Array.from(panel.querySelectorAll('button,a[href],input')).filter(function (node) { return !node.disabled && node.getBoundingClientRect().height > 0 && getComputedStyle(node).visibility !== 'hidden'; });
        var first = items[0];
        var last = items[items.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
      }
    }, true);
    window.addEventListener('boost-sd-isw-rendered', function (event) {
      install();
      sync();
      if (panel && (!interacted || decode(event.detail?.data?.query) === query.trim()) && !dismissed) {
        clearTimeout(statusTimer);
        showStatus('', false);
      }
    });
    window.addEventListener('resize', function () { viewport(); schedule(); });
    window.visualViewport?.addEventListener('resize', viewport);
    window.visualViewport?.addEventListener('scroll', viewport);
    mobile.addEventListener('change', function () { if (panel) close(); schedule(); });
    window.addEventListener('pageshow', function (event) { if (event.persisted) { dismissed = false; schedule(); } });
    window.addEventListener('storage', function (event) { if (event.key === historyKey) refreshHistory(); });
    sync();
  }

  window.dwMobileSearch = { version: '2026-10-10', refreshHistory: refreshHistory };
  if (document.body) start();
  else document.addEventListener('DOMContentLoaded', start, { once: true });
}());
